module.exports = new __parcel__URL__("twofa.9bfb0c0a.svg").toString();